export enum Permissions {
  canViewActivities = 'canViewActivities',
  canEditActivities = 'canEditActivities',
  isDriver = 'isDriver',
  canViewBillingData = 'canViewBillingData',
  canEditBillingData = 'canEditBillingData',
  canEditCompany = 'canEditCompany',
  canRemoveCompany = 'canRemoveCompany',
  canViewDelegations = 'canViewDelegations',
  canEditDelegations = 'canEditDelegations',
  canAddDriver = 'canAddDriver',
  canCreateCompany = 'canCreateCompany',
  canImportFiles = 'canImportFiles',
  canReadDatabaseLogin = 'canReadDatabaseLogin',
  canCreateUser = 'canCreateUser',
  canEditUser = 'canEditUser',
  canRemoveUser = 'canRemoveUser',
  canViewConfiguration = 'canViewConfiguration',
  canViewAlerts = 'canViewAlerts',
  canEditAlerts = 'canEditAlerts',
  canEditGpsData = 'canEditGpsData',
  canEditActivityDay = 'canEditActivityDay',
  canGenerateAttestation = 'canGenerateAttestation',
  canGeneratePrintouts = 'canGeneratePrintouts',
  canExportData = 'canExportData',
}
